import { InvestorProfileView } from './InvestorProfileView';
import { useProfile } from '../hooks/useProfile';

export function PersonalProfileTab() {
  const { data: profile, isLoading, error } = useProfile();

  if (isLoading) {
    return <p className="text-muted-foreground py-6">Loading profile...</p>;
  }

  if (error) {
    return (
      <p className="text-destructive py-6">
        Error loading profile: {error.message}
      </p>
    );
  }

  if (!profile) {
    return (
      <p className="text-muted-foreground py-6">No profile data available</p>
    );
  }

  return <InvestorProfileView contactInfo={profile.contact} />;
}
